import React from "react";
import { Tooltip } from "antd";
import { ChantSelect } from "../../../../../../CommonComponents";
import { productChoices } from "../../../constants/memberPackageConstants";
import "./MerchandiseSection.css";

const MerchandiseSection = ({
  productChoice,
  onProductChoiceChange,
  products,
  onProductsChange,
  storeItems,
}) => {
  let filteredStoreItems = (storeItems || []).filter((item) => {
    if (products.includes(item.id)) {
      return true;
    }
    return item.status === "live";
  });

  const handleProductToggle = (itemId) => {
    let updatedProducts = [...products];
    if (updatedProducts.includes(itemId)) {
      updatedProducts.splice(updatedProducts.indexOf(itemId), 1);
    } else {
      updatedProducts.push(itemId);
    }
    onProductsChange(updatedProducts);
  };

  const showMultiSelectWarning = products.length >= 2;

  return (
    <div className="merchandise-section">
      <h3 className="merchandise-section-title">
        Package includes Merchandise
      </h3>

      <div className="merchandise-sidebar">
        <p className="sidebar-text">
          Does the member package include merchandise? Add the item to the Store
          then link to the member package so that the Store Orders report can be
          used for fulfillment.
        </p>

        <div style={{ marginTop: 8 }}>
          <span className="sidebar-title">Important: </span>
          <span className="sidebar-text">
            Chant does not block members from purchasing a membership based on
            store inventory level. Track inventory accordingly.
          </span>
        </div>
      </div>

      {/* Merchandise field with sidebar */}
      <div className="merchandise-row">
        <div className="merchandise-field">
          <div className="field-label">
            <label>Include Merchandise?</label>
            <Tooltip
              placement="topLeft"
              title={() => (
                <div style={{ width: 400 }}>
                  If package includes merchandise (or choice of merchandise)
                  select one or more items. Linking the item to the package will
                  populate the Store Orders report to streamline fulfillment.
                  The product must first be added in the &apos;Store&apos;.
                  Products requiring &apos;size&apos; will use the size field
                  associated with that product.
                </div>
              )}
            >
              <span className="info-icon">
                <i className="fa fa-question-circle-o"></i>
              </span>
            </Tooltip>
          </div>
          <div className="field-select">
            <ChantSelect
              value={productChoice}
              onChange={(value) => onProductChoiceChange({ target: { value } })}
              options={productChoices.map((c) => ({ value: c, label: c }))}
            />
          </div>
        </div>
      </div>

      {/* Options section - completely separate */}
      {productChoice !== "None" && (
        <div className="options-row">
          <div className="merchandise-options">
            <div className="options-label">Select options</div>

            {showMultiSelectWarning && (
              <div className="options-sidebar">
                <h6 className="sidebar-title">Important:</h6>
                <p className="sidebar-text">
                  If subscriptions are offered with item choice (2 items) you
                  must reuse same item each season. Simply change item name in
                  the Store.
                </p>
              </div>
            )}
            <div className="options-grid">
              {filteredStoreItems.map((item) => {
                const isSelected = products.includes(item.id);
                return (
                  <div
                    key={item.id}
                    className={`option-item ${isSelected ? "selected" : ""}`}
                    onClick={() => handleProductToggle(item.id)}
                  >
                    <input
                      type="checkbox"
                      className="option-checkbox"
                      onChange={() => handleProductToggle(item.id)}
                      checked={isSelected}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <span className="option-name">{item.name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MerchandiseSection;
